// PrivacyPolicy.js

import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

const PrivacyPolicy = () => {

  
  // Obtenez la date actuelle
  const currentDate = "08 avril 2024";


  return (
    <React.Fragment>
      <Navbar />
    <div className="home-container">
      <div>
        <h1>Politique de confidentialité de l´appliation Monmarche</h1>
        <p>Bienvenue sur l'application Monmarche !</p>
        <p>
          Nous attachons une grande importance à la protection de votre vie
          privée et à la sécurité de vos données personnelles. Cette politique
          de confidentialité explique comment nous collectons, utilisons et
          protégeons les informations que vous nous fournissez lorsque vous
          utilisez notre application.
        </p>
        <h2>1. Informations collectées</h2>
        <p>
          Lorsque vous utilisez l'application Monmarche, nous pouvons collecter
          les types d'informations suivants :
        </p>
        <ul>
          <li>
            Informations d'identification personnelles : nom, adresse, numéro de
            téléphone, adresse e-mail, et toute autre information que vous
            choisissez de nous fournir.
          </li>
          <li>
            Informations de transaction : détails des transactions effectuées
            via l'application, y compris les produits achetés, les montants
            payés et les méthodes de paiement utilisées.
          </li>
          <li>
            Informations d'utilisation : données sur la manière dont vous
            utilisez l'application, telles que les pages visitées, les produits
            consultés, les clics et autres interactions avec l'application.
          </li>
        </ul>

        <h2>2. Utilisation des informations</h2>
        <p>Nous utilisons les informations collectées dans le but de :</p>
        <ul>
          <li>
            Fournir et améliorer nos services, y compris la personnalisation de
            l'expérience utilisateur et le traitement des transactions.
          </li>
          <li>
            Communiquer avec vous concernant votre compte, vos commandes et les
            mises à jour de nos services.
          </li>
          <li>
            Analyser les tendances d'utilisation de l'application et recueillir
            des informations statistiques pour améliorer nos offres et notre
            marketing.
          </li>
          <li>
            Répondre aux demandes d'assistance et aux questions des
            utilisateurs.
          </li>
        </ul>

        <h2>3. Partage des informations</h2>
        <p>
          Nous ne partagerons vos informations personnelles avec des tiers que
          dans les circonstances suivantes :
        </p>
        <ul>
          <li>
            Avec des fournisseurs de services tiers qui nous aident à fournir et
            à améliorer nos services, tels que les prestataires de paiement et
            les services de livraison.
          </li>
          <li>
            Lorsque cela est nécessaire pour se conformer à la loi, protéger nos
            droits ou répondre à une demande gouvernementale.
          </li>
        </ul>
        <p>
          Nous ne vendons pas, ne louons pas et ne partageons pas vos
          informations personnelles avec des tiers à des fins de marketing sans
          votre consentement explicite.
        </p>

        <h2>4. Sécurité des informations </h2>
        <p>
          Nous prenons des mesures de sécurité appropriées pour protéger vos
          informations personnelles contre l'accès non autorisé, la divulgation,
          l'altération ou la destruction. Cela inclut des mesures telles que
          l'accès restreint aux informations et la surveillance régulière de nos
          systèmes.
        </p>

        <h2>5. Vos droits</h2>
        <p>
          Vous avez le droit d'accéder à vos informations personnelles, de les
          mettre à jour, de les corriger ou de les supprimer. Vous pouvez
          également vous opposer au traitement de vos données personnelles ou
          demander leur portabilité. Pour exercer ces droits ou poser des
          questions sur notre politique de confidentialité, veuillez nous
          contacter à [monmarchegn@gmail.com].
        </p>

        <h2>6. Modifications de la politique de confidentialité</h2>
        <p>
          Nous pouvons mettre à jour cette politique de confidentialité de temps
          à autre pour refléter les changements dans nos pratiques de collecte
          et de traitement des informations. Nous vous informerons de toute
          modification importante en affichant la nouvelle politique sur notre
          site web ou en vous envoyant une notification via l'application.
        </p>
        <p>
          En utilisant l'application Monmarche, vous acceptez cette politique de
          confidentialité. Si vous n'acceptez pas cette politique, veuillez ne
          pas utiliser notre application.
        </p>
        <p>
          Nous vous remercions de votre confiance en choisissant Monmarche pour
          vos besoins en matière de shopping en ligne. Si vous avez des
          questions ou des préoccupations concernant notre politique de
          confidentialité, veuillez nous contacter à l'adresse e-mail fournie
          ci-dessus
        </p>
      </div>
    <Footer/>
    <p>Dernière mise à jour : {currentDate}</p>
    
    </div>
    </React.Fragment>
  );
};

export default PrivacyPolicy;
